import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill='#202020'
      fillOpacity='0.5' viewBox="0 0 24 24">
      <path fill="#202020" d="M12 11.181L8.11 15 7 13.91 12 9l5 4.91L15.89 15 12 11.181z" />
    </svg>
  )
}

export default Icon

